export default __webpack_public_path__ + "515221e5ac568a068b398e37e1b98483.png";